import React from 'react';
import { motion } from 'framer-motion';
import { trackAddToCart } from '../utils/metaPixel';
const includes = [{
  text: 'Guía Principal: Frases listas para conversaciones difíciles (45 páginas)',
  bold: 'Guía Principal:'
}, {
  text: 'Formato PDF · Compatible con iPad, iPhone, tablet y PC',
  bold: null
}, {
  text: 'Ejercicios prácticos imprimibles en cada capítulo',
  bold: null
}, {
  text: 'Acceso inmediato tras el pago',
  bold: null
}];
export function PriceSection() {
  return <section id="precio" className="py-24 px-5 bg-[#FAFAF7] text-center" data-id="element-121">
      <div className="max-w-5xl mx-auto" data-id="element-122">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-123">
          <div className="inline-block text-xs font-bold tracking-[3px] uppercase text-[#F4A535] mb-4" data-id="element-124">
            Inversión en tu familia
          </div>

          <h2 className="text-3xl md:text-4xl lg:text-5xl text-[#1A2744] mb-4" data-id="element-125">
            Si sientes que perdiste la conexión con tu hijo, esta guía te da un
            plan claro.
          </h2>

          <p className="text-lg text-[#718096] max-w-xl mx-auto mb-12" data-id="element-126">
            Sin suscripciones. Sin renovaciones. Tuyo para siempre.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-white border-2 border-[#E2E8F0] rounded-3xl p-10 md:p-12 max-w-lg mx-auto shadow-[0_20px_60px_rgba(0,0,0,0.08)] relative overflow-hidden" data-id="element-127">
          <div className="absolute top-5 -right-7 bg-[#E53E3E] text-white text-xs font-bold tracking-wide px-10 py-2 rotate-[35deg]" data-id="element-128">
            🔥 MÁS VENDIDO
          </div>

          <h3 className="text-2xl font-bold text-[#1A2744] mb-1" data-id="element-129">
            Guia Completo Adolescencia Sin Miedo
          </h3>

          <ul className="text-left space-y-3 mb-9" data-id="element-130">
            {includes.map((item, index) => <li key={index} className="flex items-center gap-3 text-sm text-[#4A5568] py-3 border-b border-[#F0F4F0]" data-id="element-131">
                <span className="text-[#38A169] text-lg flex-shrink-0" data-id="element-132">✅</span>
                <span data-id="element-133">
                  {item.bold && <strong data-id="element-134">{item.bold}</strong>}{' '}
                  {item.text.replace(item.bold || '', '')}
                </span>
              </li>)}
          </ul>

          <div id="precio-cta" className="mb-1" data-id="element-135">
            <span className="inline-block bg-[#E53E3E] text-white text-sm font-bold tracking-wide px-5 py-2 rounded-full mb-4" data-id="element-136">
              🔥 60% DE DESCUENTO
            </span>
            <p className="text-base text-[#A0AEC0] line-through mb-1" data-id="element-137">
              Valor total: $19.99 USD
            </p>
            <div className="text-6xl md:text-7xl font-black text-[#1A2744] leading-none mb-1" data-id="element-138">
              <sup className="text-3xl align-top mt-3 inline-block" data-id="element-139">$</sup>7
              <sup className="text-3xl align-top mt-3 inline-block" data-id="element-140">.99</sup>
            </div>
          </div>
          <p className="text-sm text-[#A0AEC0] mb-8" data-id="element-141">
            USD · Pago único · Sin sorpresas
          </p>

          <a href="https://cuidodemisalud.com/cart/47714670411963:1" target="_blank" rel="noopener noreferrer" onClick={() => trackAddToCart()} className="block bg-gradient-to-r from-[#F4A535] to-[#E8851A] text-[#1A2744] text-xl font-extrabold px-10 py-5 rounded-full shadow-[0_8px_25px_rgba(244,165,53,0.4)] transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_15px_35px_rgba(244,165,53,0.5)] mb-5" data-id="element-142">
            Quiero reconectar con mi hijo
          </a>

          <div className="flex justify-center gap-5 flex-wrap text-xs text-[#A0AEC0]" data-id="element-143">
            <span className="flex items-center gap-1" data-id="element-144">🔒 Pago 100% Seguro</span>
            <span className="flex items-center gap-1" data-id="element-145">📱 Acceso Inmediato</span>
            <span className="flex items-center gap-1" data-id="element-146">💰 Garantía 7 Días</span>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="max-w-lg mx-auto mt-10 bg-white rounded-2xl p-8 border-2 border-dashed border-[#38A169] text-center" data-id="element-147">
          <div className="text-5xl mb-3" data-id="element-148">🛡️</div>
          <h3 className="text-[#38A169] font-bold text-lg mb-3" data-id="element-149">
            Garantía Total 7 Días
          </h3>
          <p className="text-sm text-[#718096]" data-id="element-150">
            Si en los próximos 7 días sientes que esta guía no era lo que
            necesitabas, te devolvemos el 100% de tu dinero. Sin preguntas. Sin
            complicaciones. Así de seguros estamos de lo que tienes en tus
            manos.
          </p>
        </motion.div>
      </div>
    </section>;
}